import React from 'react';
import moment from "moment";
import {PAGINATION} from "ubs-framework/v2/common/constant";
import {getName} from "ubs-framework/v2/common/function";

export const startDate = new Date(moment().subtract(6, 'days').set({'hour': 0, 'minute': 0, 'second': 0}));
export const endDate = new Date(moment().set({'hour': 0, 'minute': 0, 'second': 0}));

const initialState = {
    socketId: '',
    _id: '',
    interviewList: {
        currentPage: PAGINATION.CURRENT_PAGE,
        limit: PAGINATION.LIMIT,
        search: '',
        candidate: null,
        interviewType: null,
        interviewer: null,
        status: null,
        date: null,
        job: null
    }
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'AUTHENTICATE': {
            return {
                ...state,
                _id: action.payload?._id,
                interviewList: {...state.interviewList, interviewer: {_id: action.payload?._id, label: getName(action.payload), value: action.payload?._id}}
            };
        }
        case 'FILTER_INTERVIEW_LIST': {
            return {...state, interviewList: {...state.interviewList, currentPage: PAGINATION?.CURRENT_PAGE, ...action.payload}}
        }

        default: {
            return state;
        }
    }
}
